import createCardListingView from './createCardListingView';
import FlexFullwidthCard from './FlexFullwidthCard';

export default createCardListingView(FlexFullwidthCard, {
  displayName: 'FullwidthListingView',
});
